import { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Row from "react-bootstrap/Row";
import "../../assets/css/scss/main.css";
import RightSideBanner from "./RightSideBanner";
import { Link, useNavigate } from "react-router-dom";
import {
  EmailCheck,
  OrganizationReg,
} from "../../redux/auth-reducer/auth-service";
import { signUpMessage } from "../../utils/helper/emailVerification";
// SP-11: import { ZIP_LOOKUP_URL } from "../../utils/config/config";
import { useZipLookup, ZIP_LENGTH } from "../../utils/hooks/useZipLookup";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Modal } from "react-bootstrap";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import flags from "react-phone-number-input/flags";
import { NAME_PATTERN } from "../../utils/helper/names";
import {
  CONFIRM_PASSWORD_REQUIRED,
  PASSWORDS_MISMATCH,
  PASSWORD_HINT,
  PHONE_INVALID,
  emailError,
  isValidEmail,
  isValidPassword,
  passwordError,
  passwordsDiffer,
  personNameError,
} from "../../utils/helper/validation";
import {
  COUNTRY_CODE_ERROR,
  effectiveCallingCode,
  isCountryCallingCode,
} from "../../utils/helper/phone";
import { PasswordToggle } from "../../CommonComponent/PasswordToggle";
import { BackButton } from "../../CommonComponent/BackButton";

function Organization() {
  const [validated, setValidated] = useState(false);
  const [smShow, setSmShow] = useState(false);
  // What the thank-you dialog says next: where the verification link went, or how to get one.
  const [signUpNote, setSignUpNote] = useState("");
  let [visible, setVisible] = useState(false);
  let [visibleIcon, setVisibleIcon] = useState(false);
  // WA-006: isVisible fed isPrivate on the organization record, and has no reader left.
  // const [isVisible] = useState(false);
  //
  // isVisibleCompany survives although the checkbox that set it is commented out: it can no
  // longer become true, so the validation fork in handleSubmit always takes the manager branch -
  // which leaves that if/else compiling untouched rather than having to be unwrapped. The setter
  // is dropped from the destructure, matching how isPlayer is declared just below.
  // const [isVisibleCompany, setIsVisibleCompany] = useState(false);
  //
  // #108: that fork is gone - handleSubmit now validates the whole form in one pass - so the
  // flag has no reader left either. Restore it together with the Company Info section.
  // const [isVisibleCompany] = useState(false);
  const [isPlayer] = useState(false);
  const [isValid, setIsValid] = useState(true);
  const [, setErrMessage] = useState(false);
  // WA-006: const [checked, setChecked] = useState(false);       // "same address as above"
  // SP-11: the postcode lookup moves to the shared hook - time limit, cancellation, and an error
  // the form actually shows. Note the old `const [, setError]` here: the error was written to
  // state that had no reader at all, by construction.
  // const [location, setLocation] = useState(null);
  // WA-006: const [locationOrg, setLocationOrg] = useState(null);  // org address lookup
  // const [, setError] = useState("");
  const {
    location,
    error: zipError,
    loading: zipLoading,
    lookup: lookupZip,
    reset: resetZip,
  } = useZipLookup();
  // #286: Country, State/Province and City can be typed in until a valid zip code fills all
  // three; only then are they locked to the lookup's values.
  const zipCountry = location?.country;
  const zipState = location?.places?.[0]?.state;
  const zipCity = location?.places?.[0]?.["place name"];
  const addressFromZip = !!(zipCountry && zipState && zipCity);
  const [countryCode, setCountryCode] = useState("");
  const [regForm, setRegForm] = useState({
    emailId: "",
    firstName: "",
    lastName: "",
    phoneNumber: "",
    address: "",
    country: "",
    state: "",
    city: "",
    zipCode: null,
    isPlayer: "",
    // WA-006:
    // orgName: null,
    // orgEmailId: null,
    // orgAddress: null,
    // orgCountry: null,
    // orgState: null,
    // orgCity: null,
    // orgZipCode: "",
    countryCode: null,
    password: "",
    confirmPassword: "",
  });
  const [err, setErr] = useState("");
  const navigate = useNavigate();
  const handleSubmit = async (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    // #108: every field is checked in one pass and highlighted together. This used to stop at the
    // first problem - a toast for the phone prefix before anything was highlighted, then a check
    // of five fields only, then an email-format failure written to state nothing renders - and
    // anything those missed (the phone pattern, the password rule, a mismatch) went to the server
    // to be refused one at a time.
    setValidated(true);

    // if (!countryCode || countryCode.trim() === "") {
    //   toast.error("Phone number prefix should not be empty");
    //   return;
    // }
    const nativeValid = form.checkValidity();
    if (
      !nativeValid ||
      phonePrefixMissing ||
      emailFormatInvalid ||
      !isPasswordValid(regForm?.password) ||
      err
    ) {
      return;
    }

    const data = {
      crudOperationId: true,
      emailId: regForm?.emailId,
      firstName: regForm?.firstName,
      lastName: regForm?.lastName,
      phoneNumber: regForm?.phoneNumber,
      address: regForm?.address,
      country: addressFromZip ? zipCountry : regForm?.country.trim(),
      state: addressFromZip ? zipState : regForm?.state.trim(),
      city: addressFromZip ? zipCity : regForm?.city.trim(),
      zipCode: Number(regForm?.zipCode) || 0,
      isPlayer: isPlayer,
      // WA-006: countryCode below is the PHONE prefix, not an organization field. It sits in the
      // middle of this block and must keep being sent.
      // orgName: regForm?.orgName,
      countryCode: Number(effectiveCallingCode(regForm.countryCode)),
      // orgEmailId: regForm?.orgEmailId,
      // orgAddress: regForm?.orgAddress,
      // orgCountry: locationOrg?.country,
      // orgState: locationOrg?.["places"][0]["state"],
      // orgCity: locationOrg?.["places"][0]["place name"],
      // orgZipCode: Number(regForm?.orgZipCode),
      // isPrivate: isVisible,
      // isCompany: isVisibleCompany,
      isActive: true,
      password: regForm?.password,
      confirmPassword: regForm?.confirmPassword,
    };

    // #108: the required fields are checked above, together with everything else.
    // isVisibleCompany can no longer become true (WA-006), so its orgName/orgEmailId branch is
    // unreachable.
    //
    // if (isVisibleCompany) {
    //   if (!regForm?.orgName || !regForm?.orgEmailId) {
    //     setValidated(true);
    //     return;
    //   }
    // } else {
    //   if (
    //     !regForm?.firstName ||
    //     !regForm?.phoneNumber ||
    //     !regForm?.emailId ||
    //     !regForm?.password ||
    //     !regForm?.confirmPassword
    //   ) {
    //     setValidated(true);
    //     return;
    //   }
    // }
    //
    // var mailformat = /^[\w\.-]+@[a-zA-Z\d\.-]+\.[a-zA-Z]{2,}$/;
    // if (regForm?.emailId?.match(mailformat)) {
    setErrMessage(false);
    try {
      await OrganizationReg(data).then((res) => {
        // #108: OrganizationReg returns the whole axios response (or error.response), so
        // `res.status` is the HTTP code - and every answer has one. A refusal such as "Manager
        // already registered with this email id" arrives as HTTP 200 with status false in the
        // body, and a validation error as 400; both showed "You are successfully registered".
        // if (res?.status) {
        if (res?.data?.status === true) {
          setSignUpNote(signUpMessage(res.data, regForm?.emailId));
          setSmShow(true);
          setRegForm("");
        } else {
          // toast.error("Please Fill the Field");
          toast.error(
            res?.data?.message ||
              res?.data?.title ||
              "Registration failed. Please try again."
          );
        }
      });
    } catch (error) {
      toast.error(error?.response?.data?.title);
    }
    // } else {
    //   setErrMessage(true);
    // }
  };

  // #108: conditions the browser cannot check on its own. They are rendered next to their fields
  // from these same values, so what blocks the submit is always what is shown.
  //
  // The prefix lives in the PhoneInput, not in a native input. #250: until the user picks a
  // country it stands for the +1 it shows (this used to demand a pick while showing +1), and digits
  // typed into it ("+1" -> "+199") make a code no country has, which used to be sent as is.
  const phonePrefixMissing = !isCountryCallingCode(countryCode);
  // type="email" accepts "a@b"; this is the stricter rule (#274: the shared one).
  const emailFormatInvalid = !!regForm?.emailId && !isValidEmail(regForm.emailId);

  useEffect(() => {
    if (regForm.countryCode) {
      setCountryCode(`+${regForm.countryCode}`);
    }
  }, [regForm.countryCode]);

  const handelPhoneCountryCode = async (e) => {
    // #250: undefined when the picker has no code; it used to be stored as "+undefined".
    const newCountryCode = e ? e.replace("+", "") : "";
    setCountryCode(newCountryCode ? `+${newCountryCode}` : "");
    setRegForm((prevForm) => ({
      ...prevForm,
      countryCode: newCountryCode,
    }));
  };

  const handelform = async (e) => {
    setRegForm({
      ...regForm,
      [e.target.name]: e.target.value.trim(),
    });
    setErrMessage(true);
  };

  // #286: the address parts keep inner spaces ("New York"); they are trimmed on submit.
  const handleAddressPart = (e) => {
    setRegForm({
      ...regForm,
      [e.target.name]: e.target.value.replace(/^\s+/, ""),
    });
  };

  const handelformPass = (e) => {
    setRegForm({
      ...regForm,
      [e.target.name]: e.target.value.trim(),
    });
    setIsValid(isPasswordValid(e.target.value));
  };
  // #274: the shared rule, which Organization.Password's RegularExpression applies too (8+).
  const isPasswordValid = isValidPassword;

  async function selectEmail(email) {
    const data = {
      email: email,
    };
    await EmailCheck(data).then((res) => {
      if (res?.data?.status === true) {
        toast.error(res?.data?.message);
      } else {
      }
    });
  }

  const handelEmail = (e) => {
    setRegForm({
      ...regForm,
      [e.target.name]: e.target.value,
    });
    const value = e.target.value;

    const EmailExist = value.match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );

    if (EmailExist) {
      selectEmail(value);
    } else {
      return;
    }
  };

  const RequestDemo = () => {
    navigate("/Home");
  };

  // WA-006:
  // const handelCompany = (event) => {
  //   setIsVisibleCompany(event.target.checked);
  // };
  const show = (event) => {
    setVisible(!visible);
  };
  const showIcon = () => {
    setVisibleIcon(!visibleIcon);
  };
  useEffect(() => {
    setErr(passwordsDiffer(regForm?.password, regForm?.confirmPassword) ? PASSWORDS_MISMATCH : "");
  }, [regForm?.password, regForm?.confirmPassword]);

  const handleKeyDown = (e) => {
    if (e.key === " ") {
      e.preventDefault();
    }
  };

  const handleKeypress = (e) => {
    const characterCode = e.key;
    if (characterCode === "Backspace") return;

    const characterNumber = Number(characterCode);
    if (characterNumber >= 0 && characterNumber <= 9) {
      if (e.currentTarget.value && e.currentTarget.value.length) {
        return;
      } else if (characterNumber === 0) {
        e.preventDefault();
      }
    }
  };

  // WA-006: the "same address as above" handler and the effect that mirrored the manager's
  // address into the organization fields.
  // const handleSameDetail = () => {
  //   setChecked(!checked);
  // };
  //
  // useEffect(() => {
  //   if (checked) {
  //     setRegForm((prevValue) => ({
  //       ...prevValue,
  //       orgAddress: prevValue?.address || "",
  //       orgCountry: prevValue?.country || "",
  //       orgState: prevValue?.state || "",
  //       orgCity: prevValue?.city || "",
  //       orgZipCode: prevValue?.zipCode,
  //     }));
  //     setLocationOrg(location);
  //   } else {
  //     setRegForm((prevValue) => ({
  //       ...prevValue,
  //       orgAddress: "",
  //       orgCountry: "",
  //       orgState: "",
  //       orgCity: "",
  //       orgZipCode: "",
  //     }));
  //     setLocationOrg(null);
  //   }
  // }, [checked, location]);

  const handelZipCode = async (e) => {
    const zipCode = e.target.value;
    setRegForm({
      ...regForm,
      [e.target.name]: zipCode,
    });
    if (zipCode.length === ZIP_LENGTH) {
      await lookupZip(zipCode);
    } else {
      resetZip();
    }
  };

  // SP-11:
  // const handelZipCode = async (e) => {
  //   const zipCode = e.target.value;
  //   setRegForm({ ...regForm, [e.target.name]: zipCode });
  //   if (zipCode.length == 5) {
  //     try {
  //       const response = await fetch(`${ZIP_LOOKUP_URL}${zipCode}`);
  //       if (!response.ok) {
  //         throw new Error("Zip code not found");
  //       }
  //       const data = await response.json();
  //       setLocation(data);
  //       setError("");
  //     } catch (err) {
  //       setError(err.message);
  //       setLocation(null);
  //     }
  //   }
  // };

  // WA-006: the SECOND postcode lookup, for the organization address. With the Company Info
  // section gone this page has a single lookup left - see handelZipCode above, which SP-11 moves
  // onto the shared useZipLookup hook.
  // const handelZipCodeOrg = async (e) => {
  //   const zipCodeOrg = e.target.value;
  //   setRegForm({
  //     ...regForm,
  //     [e.target.name]: zipCodeOrg,
  //   });
  //   if (zipCodeOrg.length == 5) {
  //     try {
  //       const response = await fetch(
  //         `${ZIP_LOOKUP_URL}${zipCodeOrg}`
  //       );
  //       if (!response.ok) {
  //         throw new Error("Zip code not found");
  //       }
  //       const data = await response.json();
  //       setLocationOrg(data);
  //       setError("");
  //     } catch (err) {
  //       setError(err.message);
  //       setLocationOrg(null);
  //     }
  //   }
  // };

  return (
    <>
      <Modal show={smShow} centered>
        <div className="group-modal">
          <img src="./image/popup-box.svg" className="img-fluid" />
          <div className="icons-check">
            <img src="./image/check.svg" />
          </div>
        </div>
        <Modal.Body className="thankyouModal">
          <h2 className="text-center p-2 mt-4">
            <b>Thank you</b>
          </h2>
          <p className="text-center">You are successfully registered</p>
          {signUpNote && <p className="text-center">{signUpNote}</p>}
          <div className="text-center">
            <Button
              type="button"
              onClick={RequestDemo}
              className="button_back_login"
            >
              {" "}
              <b>Go To Home</b>
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      <div className="grop-section">
        <div className="icon-back">
          <BackButton />
        </div>
        <div className="group-reg">
          <div className="item">
            <div className="inner-item">
              <div className="form-contnet">
                <Link to="/Home">
                  {" "}
                  <img src="../image/logo1.png" className="logo-mob-img" />
                </Link>
                <h1 className="heading">Create a new account </h1>
              </div>
              <h3>
                <b>Manager Info</b>
              </h3>
              <div className="line"></div>

              <Form
                noValidate
                validated={validated}
                className="registration"
                onSubmit={handleSubmit}
              >
                <Row className="mb-3 mt-3">
                  <Form.Group
                    as={Col}
                    md="6"
                    controlId="validationCustomFristname"
                  >
                    <Form.Label>First name</Form.Label>{" "}
                    <span
                      style={{
                        color: "#f44336",
                        fontSize: "20px",
                        marginLeft: "-1px",
                      }}
                    >
                      *
                    </span>
                    <InputGroup hasValidation>
                      <Form.Control
                        type="text"
                        onChange={handelform}
                        onKeyPress={(e) => {
                          if (
                            e.key === " " &&
                            (regForm?.firstName.trim() === "" ||
                              e.target.selectionStart === 0)
                          ) {
                            e.preventDefault();
                          }
                        }}
                        name="firstName"
                        placeholder="Enter your first name"
                        aria-describedby="inputGroupPrepend"
                        // #253: letters, spaces, apostrophes and hyphens, as the API checks.
                        pattern={NAME_PATTERN}
                        required
                      />
                      <Form.Control.Feedback type="invalid">
                        {personNameError("first name", regForm?.firstName)}
                      </Form.Control.Feedback>
                    </InputGroup>
                  </Form.Group>

                  <Form.Group
                    as={Col}
                    md="6"
                    className="text-left"
                    controlId="validationCustomLastname"
                  >
                    <Form.Label>Last name</Form.Label>
                    <InputGroup hasValidation>
                      <Form.Control
                        type="text"
                        onChange={handelform}
                        onKeyPress={(e) => {
                          if (
                            e.key === " " &&
                            (regForm?.lastName.trim() === "" ||
                              e.target.selectionStart === 0)
                          ) {
                            e.preventDefault();
                          }
                        }}
                        name="lastName"
                        placeholder="Enter your last name"
                        aria-describedby="inputGroupPrepend"
                        // #253: optional, so an empty value passes; anything typed follows the rule.
                        pattern={NAME_PATTERN}
                      />
                      <Form.Control.Feedback type="invalid">
                        {personNameError("last name", regForm?.lastName)}
                      </Form.Control.Feedback>
                    </InputGroup>
                  </Form.Group>

                  <Form.Group
                    as={Col}
                    md="6"
                    controlId="validationCustomPhoneNumber"
                  >
                    <Form.Label>Phone number</Form.Label>
                    <span
                      style={{
                        color: "#f44336",
                        fontSize: "20px",
                        marginLeft: "4px",
                      }}
                    >
                      *
                    </span>
                    <InputGroup hasValidation>
                      <div className="d-flex flex-wrap group-ph">
                        <PhoneInput
                          type="text"
                          international
                          // undefined, not "": the picker resets an empty string to
                          // defaultCountry and would hide that no country is chosen.
                          value={countryCode || undefined}
                          onChange={handelPhoneCountryCode}
                          flags={flags}
                          defaultCountry="US"
                          countryCallingCodeEditable={false}
                        />
                        <Form.Control
                          type="text"
                          name="phoneNumber"
                          onChange={handelform}
                          className="phone-number-input"
                          onKeyDown={handleKeypress}
                          maxlength="10"
                          pattern="[1-9]{1}[0-9]{9}"
                          value={regForm?.phoneNumber}
                          placeholder="Enter your phone number"
                          aria-describedby="inputGroupPrepend"
                          required
                        />
                        {/* #108: must be the input's sibling - Bootstrap reveals it with
                            `:invalid ~ .invalid-feedback`, which never matched from outside
                            .group-ph. w-100 plus flex-wrap put it on its own line. */}
                        <Form.Control.Feedback type="invalid" className="w-100">
                          {PHONE_INVALID}
                        </Form.Control.Feedback>
                      </div>
                      {/* #108: was a toast shown before anything else was checked. */}
                      {validated && phonePrefixMissing && (
                        <Form.Control.Feedback type="invalid" className="d-block">
                          {COUNTRY_CODE_ERROR}
                        </Form.Control.Feedback>
                      )}
                    </InputGroup>
                  </Form.Group>

                  <Form.Group as={Col} md="6" className="text-left">
                    <Form.Label>Email</Form.Label>
                    <span
                      style={{
                        color: "#f44336",
                        fontSize: "20px",
                        marginLeft: "4px",
                      }}
                    >
                      *
                    </span>
                    <InputGroup hasValidation>
                      <Form.Control
                        type="email"
                        onChange={handelEmail}
                        name="emailId"
                        maxlength="50"
                        value={regForm?.emailId}
                        onKeyDown={handleKeyDown}
                        placeholder="Enter your email"
                        autocomplete="off"
                        required
                        // #108: the stricter format check used to fail silently.
                        isInvalid={validated && emailFormatInvalid}
                      />
                      <Form.Control.Feedback type="invalid">
                        {emailError(regForm?.emailId)}
                      </Form.Control.Feedback>
                    </InputGroup>
                  </Form.Group>

                  <Form.Group
                    as={Col}
                    md="12"
                    className="text-left"
                    controlId="validationCustomCompanyAddress"
                  >
                    <Form.Label>Address</Form.Label>
                    <InputGroup hasValidation>
                      <Form.Control
                        type="text"
                        onChange={handelform}
                        onKeyPress={(e) => {
                          if (
                            e.key === " " &&
                            (regForm?.address.trim() === "" ||
                              e.target.selectionStart === 0)
                          ) {
                            e.preventDefault();
                          }
                        }}
                        name="address"
                        placeholder="Enter your address"
                        aria-describedby="inputGroupPrepend"
                        // #108: no `required`. The address was never enforced - no asterisk, no
                        // message, not in the old submit check, optional on the server - and
                        // with checkValidity() now gating the submit the attribute would have
                        // made it mandatory at sign-up for the first time.
                        // required
                      />
                    </InputGroup>
                  </Form.Group>

                  <Form.Group
                    as={Col}
                    md="6"
                    className="text-left"
                    controlId="validationCustomZipCode"
                  >
                    <Form.Label>Zip/Province code</Form.Label>

                    <InputGroup hasValidation>
                      <Form.Control
                        type="text"
                        onChange={(e) => {
                          handelZipCode(e);
                        }}
                        onKeyPress={(e) => {
                          if (
                            e.key === " " &&
                            (regForm?.zipCode?.trim() === "" ||
                              e.target.selectionStart === 0)
                          ) {
                            e.preventDefault();
                          }
                        }}
                        name="zipCode"
                        placeholder="Enter zip code"
                        aria-describedby="inputGroupPrepend"
                        maxLength="10"
                        // SP-11: a failed lookup marks the field invalid, so the form cannot be
                        // submitted with country/state/city left empty.
                        isInvalid={!!zipError}
                      />
                      {/* SP-11: the lookup finally says what it is doing, and why it failed. */}
                      {zipLoading && (
                        <Form.Text className="form-hint w-100">
                          Looking up your address&hellip;
                        </Form.Text>
                      )}
                      <Form.Control.Feedback type="invalid">
                        {zipError}
                      </Form.Control.Feedback>
                    </InputGroup>
                  </Form.Group>

                  <Form.Group
                    as={Col}
                    md="6"
                    className="text-left"
                    controlId="validationCustomCountry"
                  >
                    <Form.Label>Country</Form.Label>

                    <InputGroup hasValidation>
                      <Form.Control
                        type="text"
                        onChange={handleAddressPart}
                        name="country"
                        maxlength="50"
                        value={addressFromZip ? zipCountry : regForm?.country}
                        disabled={addressFromZip}
                        placeholder="Enter your country"
                      />
                      {addressFromZip && (
                        <Form.Text className="form-hint w-100">Filled automatically from a valid Zip code.</Form.Text>
                      )}
                    </InputGroup>
                  </Form.Group>

                  <Form.Group
                    as={Col}
                    md="6"
                    className="text-left"
                    controlId="validationCustomState"
                  >
                    <Form.Label>State/Province</Form.Label>
                    <InputGroup hasValidation>
                      <Form.Control
                        type="text"
                        onChange={handleAddressPart}
                        name="state"
                        maxlength="50"
                        value={addressFromZip ? zipState : regForm?.state}
                        disabled={addressFromZip}
                        placeholder="Enter your state"
                      />
                      {addressFromZip && (
                        <Form.Text className="form-hint w-100">Filled automatically from a valid Zip code.</Form.Text>
                      )}
                    </InputGroup>
                  </Form.Group>

                  <Form.Group as={Col} md="6" className="text-left">
                    <Form.Label>City name</Form.Label>
                    <InputGroup hasValidation>
                      <Form.Control
                        type="text"
                        onChange={handleAddressPart}
                        name="city"
                        disabled={addressFromZip}
                        maxlength="50"
                        value={addressFromZip ? zipCity : regForm?.city}
                        placeholder="Enter your city"
                      />
                      {addressFromZip && (
                        <Form.Text className="form-hint w-100">Filled automatically from a valid Zip code.</Form.Text>
                      )}
                    </InputGroup>
                  </Form.Group>

                  <Form.Group as={Col} md="6">
                    <Form.Label>Password</Form.Label>
                    <span
                      style={{
                        color: "#f44336",
                        fontSize: "20px",
                        marginLeft: "4px",
                      }}
                    >
                      *
                    </span>
                    <InputGroup hasValidation>
                      <Form.Control
                        type={visible ? "text" : "password"}
                        onChange={handelformPass}
                        value={regForm?.password}
                        autoComplete="off"
                        name="password"
                        maxLength={20}
                        placeholder="Enter password"
                        aria-describedby="inputGroupPrepend"
                        isInvalid={!isValid}
                        required
                      />
                      <PasswordToggle visible={visible} onToggle={show} />

                      <Form.Control.Feedback type="invalid">
                        {passwordError(regForm?.password)}
                      </Form.Control.Feedback>
                      {/* #258: the rules are shown before input; the error above replaces them once the
                          password is invalid, or empty on a submit. */}
                      {isValid && !(validated && !regForm?.password) && (
                        <Form.Text className="form-hint w-100">{PASSWORD_HINT}</Form.Text>
                      )}
                    </InputGroup>
                  </Form.Group>
                  <Form.Group as={Col} md="6">
                    <Form.Label>Confirm password</Form.Label>
                    <span
                      style={{
                        color: "#f44336",
                        fontSize: "20px",
                        marginLeft: "4px",
                      }}
                    >
                      *
                    </span>
                    <InputGroup hasValidation>
                      <Form.Control
                        type={visibleIcon ? "text" : "password"}
                        onChange={handelform}
                        value={regForm?.confirmPassword}
                        maxLength={20}
                        name="confirmPassword"
                        placeholder="Enter confirm password"
                        aria-describedby="inputGroupPrepend"
                        autoComplete="new-password"
                        required
                      />
                      <PasswordToggle visible={visibleIcon} onToggle={showIcon} />
                      {err ? (
                        <p className="err-message">{err}</p>
                      ) : (
                        <Form.Control.Feedback type="invalid">
                          {CONFIRM_PASSWORD_REQUIRED}
                        </Form.Control.Feedback>
                      )}
                    </InputGroup>
                  </Form.Group>
                  {/* WA-006: the "Do you want to add your company information?" checkbox and
                      the whole Company Info section it reveals. Organizations are removed from
                      Release 1; this page stays, as the manager sign-up form. Kept verbatim,
                      indentation included, so it can be restored as-is.

                  <Form.Group>
                    <label className="d-flex text-color-la mt-3">
                      <input
                        type="checkbox"
                        className="inputCheck"
                        onClick={handelCompany}
                        name="isCompany"
                        value={isVisibleCompany}
                      />
                      <span class="checkmark"></span>
                      Do you want to add your company information?
                    </label>
                  </Form.Group>

                  {isVisibleCompany && (
                    <div className="section-company-info">
                      <h3 className="mt-3">
                        <b>Company Info</b>
                      </h3>
                      <div className="line"></div>
                      <Form.Group
                        as={Col}
                        md="12 mt-4"
                        className="text-left"
                        controlId="validationCustomCompanyName"
                      >
                        <Form.Label>Company name</Form.Label>
                        <span
                          style={{
                            color: "#f44336",
                            fontSize: "20px",
                            marginLeft: "-1px",
                          }}
                        >
                          *
                        </span>
                        <InputGroup hasValidation>
                          <Form.Control
                            type="text"
                            onChange={handelform}
                            name="orgName"
                            placeholder="ABC"
                            aria-describedby="inputGroupPrepend"
                            required
                          />

                          <Form.Control.Feedback type="invalid">
                            Please Enter a Company name.
                          </Form.Control.Feedback>
                        </InputGroup>
                      </Form.Group>

                      <Form.Group
                        as={Col}
                        md="12"
                        className="text-left"
                        controlId="validationCustomEmail"
                      >
                        <Form.Label>Email</Form.Label>
                        <span
                          style={{
                            color: "#f44336",
                            fontSize: "20px",
                            marginLeft: "-1px",
                          }}
                        >
                          *
                        </span>
                        <InputGroup hasValidation>
                          <Form.Control
                            type="email"
                            onChange={handelEmail}
                            name="orgEmailId"
                            maxLength="50"
                            value={regForm.orgEmailId}
                            placeholder="Enter your email"
                            aria-describedby="inputGroupPrepend"
                            autoComplete="off"
                            required
                          />

                          <Form.Control.Feedback type="invalid">
                            Please Enter a Email.
                          </Form.Control.Feedback>
                        </InputGroup>
                      </Form.Group>

                      <Row>
                        <Form.Group
                          as={Col}
                          md="12"
                          className="text-left"
                          controlId="validationCustomCompanyAddress"
                        >
                          <label
                            className="d-flex text-color-la"
                            style={{ marginTop: "15px" }}
                          >
                            <input
                              type="checkbox"
                              className="inputCheck"
                              onClick={handleSameDetail}
                              name="sameAdressCheck"
                              checked={checked}
                            />
                            <span class="checkmark"></span>
                            Do you want to fill the below address details same
                            as above
                          </label>
                          <Form.Label>Address</Form.Label>
                          <InputGroup hasValidation>
                            <Form.Control
                              type="text"
                              onChange={handelform}
                              name="orgAddress"
                              placeholder="Enter your company address"
                              aria-describedby="inputGroupPrepend"
                              value={regForm?.orgAddress}
                            />
                          </InputGroup>
                        </Form.Group>
                        <Form.Group
                          as={Col}
                          md="6"
                          className="text-left"
                          controlId="validationCustomZipCode"
                        >
                          <Form.Label>Zip/Province code</Form.Label>

                          <InputGroup hasValidation>
                            <Form.Control
                              type="text"
                              onChange={handelZipCodeOrg}
                              name="orgZipCode"
                              maxLength="10"
                              placeholder="Enter zip code"
                              value={regForm.orgZipCode}
                              disabled={checked}
                            />
                          </InputGroup>
                        </Form.Group>
                        <Form.Group
                          as={Col}
                          md="6"
                          className="text-left"
                          controlId="validationCustomCountry"
                        >
                          <Form.Label>Country</Form.Label>

                          <InputGroup hasValidation>
                            <Form.Control
                              type="text"
                              onChange={handelform}
                              name="orgCountry"
                              disabled
                              maxlength="50"
                              value={locationOrg?.country || regForm.country}
                              onKeyDown={handleKeyDown}
                              placeholder="Enter your country"
                            />
                          </InputGroup>
                        </Form.Group>
                        <Form.Group
                          as={Col}
                          md="6"
                          className="text-left"
                          controlId="validationCustomState"
                        >
                          <Form.Label>State/Province</Form.Label>
                          <InputGroup hasValidation>
                            <Form.Control
                              type="text"
                              onChange={handelform}
                              name="orgState"
                              maxlength="50"
                              value={
                                locationOrg?.places?.[0]?.state || regForm.state
                              }
                              disabled
                              onKeyDown={handleKeyDown}
                              placeholder="Enter your state"
                            />
                          </InputGroup>
                        </Form.Group>

                        <Form.Group as={Col} md="6" className="text-left">
                          <Form.Label>City name</Form.Label>

                          <InputGroup hasValidation>
                            <Form.Control
                              type="text"
                              onChange={handelform}
                              name="orgCity"
                              maxlength="50"
                              disabled
                              value={
                                locationOrg?.["places"][0]["place name"] ||
                                regForm?.orgCity
                              }
                              onKeyDown={handleKeyDown}
                              placeholder="Enter your city"
                            />
                          </InputGroup>
                        </Form.Group>
                      </Row>
                    </div>
                  )}
                  */}

                  <Col md="12 submit_button">
                    <Button type="submit" className="submit">
                      Submit
                    </Button>
                  </Col>
                </Row>
              </Form>
              <p className="account-para">
                Already have an account? <a href="/Login">Login here</a>
              </p>
            </div>
          </div>
          <RightSideBanner />
        </div>
      </div>
    </>
  );
}
export default Organization;
